import React, { useState, useEffect } from "react";
import { apiPost } from "./restUtil.service";

interface Feedback {
    _id: number;
    user: any;
    feedback: string;
    createdAt: string;
}

const Feedback: React.FC = () => {
    const [feedbackList, setFeedbackList] = useState<Feedback[]>([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [isLoading, setIsLoading] = useState(false);

    const fetchFeedback = async (page: number) => {
        setIsLoading(true);
        try {
            const response = await apiPost<{ pageSize: number, lastId?: string, page: number }, { feedbacks: Feedback[]; totalPages: number }>(
                "/admin/feedback",
                { pageSize: 50, page }
            );
            setFeedbackList(response.feedbacks);
            setTotalPages(response.totalPages);
        } catch (error) {
            console.error("Error fetching feedback:", error);
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        fetchFeedback(currentPage);
    }, [currentPage]);

    const handlePageChange = (page: number) => {
        if (page >= 1 && page <= totalPages) {
            setCurrentPage(page);
        }
    };

    return (
        <div className="container mt-4">
            <h2>
                Feedback List &nbsp;&nbsp;
                <button
                    className="btn btn-sm btn-outline-primary"
                    onClick={() => handlePageChange(currentPage + 1)}
                    disabled={currentPage === totalPages}
                >
                    Next
                </button>
            </h2>
            {isLoading ? (
                <div className="text-center">
                    <div className="spinner-border text-primary" role="status">
                        <span className="visually-hidden">Loading...</span>
                    </div>
                </div>
            ) : (
                <>
                    <table className="table table-bordered">
                        <thead>
                            <tr>
                                <th>User ID</th>
                                <th>User</th>
                                <th>Message</th>
                                <th>Created At</th>
                            </tr>
                        </thead>
                        <tbody>
                            {feedbackList.length > 0 ? (
                                feedbackList.map((feedback) => (
                                    <tr key={feedback._id}>
                                        <td>{feedback.user._id}</td>
                                        <td>{feedback.user?.email || feedback.user?.mobileNumber}</td>
                                        <td>{feedback.feedback}</td>
                                        <td>{new Date(feedback.createdAt).toLocaleString()}</td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan={4} className="text-center">
                                        No feedback available.
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                    <div className="d-flex justify-content-between align-items-center">
                        <button
                            className="btn btn-primary"
                            onClick={() => handlePageChange(currentPage - 1)}
                            disabled={currentPage === 1}
                        >
                            Previous
                        </button>
                        <span>
                            Page {currentPage} of {totalPages}
                        </span>
                        <button
                            className="btn btn-primary"
                            onClick={() => handlePageChange(currentPage + 1)}
                            disabled={currentPage === totalPages}
                        >
                            Next
                        </button>
                    </div>
                </>
            )}
        </div>
    );
};

export default Feedback;